const locationTypeOrder = {
    'country': 1,
    'region': 2,
    'province': 3,
    'coast': 3,
    'municipality': 4,
    'district': 5,
    'neighbourhood': 6,
    'entity': 7,
};

export function byLocationType( l1, l2 ) {
    if ( locationTypeOrder[ l1.type ] < locationTypeOrder[ l2.type ] ) {
        return -1;
    }

    if ( locationTypeOrder[ l1.type ] > locationTypeOrder[ l2.type ] ) {
        return 1;
    }

    return 0;
};
